import { indexedDBStorage } from "../../../common/util/indexedDBStorage";

export const planSelectionPanelLastOpenedTimeStorageKey =
    "PlanSelectionPanelLastOpenedTimeStorageKey";

export async function saveCurrentDate() {
    await indexedDBStorage.setItemAsync(
        planSelectionPanelLastOpenedTimeStorageKey,
        Date.now().toString()
    );
}

export async function checkShouldOpenPlanSelectionPanel(): Promise<boolean> {
    const savedData = await indexedDBStorage.getItemAsync(
        planSelectionPanelLastOpenedTimeStorageKey
    );

    if (!savedData) {
        // 一度も開かれていない場合は今回は表示せず、9日後に表示
        await saveCurrentDate();
        return false;
    }

    const savedTimeNumber = Number(savedData);
    if (Number.isNaN(savedTimeNumber)) {
        // データが壊れている場合も今回は表示せず、9日後に表示
        await saveCurrentDate();
        return false;
    }

    const currentTimeNumber = Date.now();

    const diffMs = currentTimeNumber - savedTimeNumber;
    const thirteenDaysMs = 9 * 24 * 60 * 60 * 1000;

    return diffMs >= thirteenDaysMs; // 前回から9日分の時間が経っていれば true
}
